import * as React from 'react';
import {useEffect} from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import {Button} from '@mui/material';
import {Add, Delete, GetApp} from '@mui/icons-material';
import {useNavigate} from 'react-router-dom';
import taskTypeService from '../../services/TaskTypeService';
import {useTitle} from '../dashboard/TitleContext';
import {useSnackbar} from "../../util/SnackbarProvider";

const columns = [
    {id: 'name', label: 'Feladatkör'},
    {id: 'hourlyWage', label: 'Belső Óradíj'},
    {id: 'hourlyRate', label: 'Külső Óradíj'},
    {id: 'paymentModifier', label: 'Fizetés Módosító'},
    {id: 'paymentCategory', label: 'Fizetési Kategória'}
];

const paymentCategoryMap = {
    "PROGRAMMING_AND_PLANNING": "Programozás és Tervezés",
    "ELECTRICAL_INSTALLATION": "Villanyszerelés",
    "ACCOMMODATION": "Szállás",
    "CATEGORY_TYPE_4": "Kategória 4",
    "CATEGORY_TYPE_5": "Kategória 5",
    "TRAVELLING": "Utazás",
    "OTHER": "Egyéb"
};

export default function TaskTypeTable() {

    useTitle([{name: 'Feladatkörök'}])

    const [page, setPage] = React.useState(0);
    const [rows, setRows] = React.useState([]);
    const [rowsPerPage, setRowsPerPage] = React.useState(25);
    const {sendAlertMessage} = useSnackbar()

    useEffect(() => {
        taskTypeService.search()
            .then(response => {
                const result = response.map((taskType) => {
                    const paymentCategory = paymentCategoryMap[taskType.paymentCategory] || "ERROR";
                    return {...taskType, paymentCategory: paymentCategory}
                })
                setRows(result);
            })
            .catch(error => sendAlertMessage(error?.message || "Feladatkörök lekérése sikertelen", 'error'));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const navigate = useNavigate();

    return (
        <>
            <Paper sx={{width: '100%', overflow: 'hidden'}}>
                <TableContainer>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell key={column.id} align={column.align}
                                               style={{fontWeight: 700, background: "lightgray"}}>
                                        {column.label}
                                    </TableCell>
                                ))}
                                <TableCell key="actions"
                                           style={{fontWeight: 700, background: "lightgray", minWidth: "90px"}}
                                           align='right' padding='none'>
                                    <Button variant='contained' color='warning'
                                            sx={{minWidth: "0px", padding: "0px", marginRight: "10px"}}
                                            onClick={() => console.log("EXPORT")}>
                                        <GetApp fontSize="large"/>
                                    </Button>
                                    <Button variant='contained' color='success'
                                            sx={{minWidth: "0px", padding: "0px", marginRight: "10px"}}
                                            onClick={() => navigate("/dashboard/task-types/create")}>
                                        <Add fontSize="large"/>
                                    </Button>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows && rows
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row) => {
                                    return (
                                        <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                                            {columns.map((column) => {
                                                const value = row[column.id];
                                                return (
                                                    <TableCell key={column.id} align={column.align}
                                                               onClick={() => navigate("/dashboard/task-types/" + row.id)}
                                                               sx={{cursor: "pointer", padding: "10px"}}>
                                                        {value}
                                                    </TableCell>
                                                );
                                            })}
                                            <TableCell key="actions" padding='none' align='right'>
                                                <Button color='error' variant='contained' width='16px'
                                                        sx={{minWidth: "0px", padding: "5px", marginRight: "10px"}}
                                                        onClick={() => taskTypeService.deleteTaskType(row.id)
                                                            .then(() => navigate(0))
                                                            .catch(error => console.error(error))
                                                        }>
                                                    <Delete/>
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 100]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    labelRowsPerPage="Elemek oldalanként:"
                />
            </Paper>
        </>
    );
}
